import {
  IMPERSONATE_ACCOUNT
} from '@/store/mutation-types'
import { vueProps } from '@/vue-app'

export function stopImpersonation () {
  vueProps.$localStorage.remove(IMPERSONATE_ACCOUNT)
  location.reload()
}
